(() => {
  const root = document.querySelector('[data-om-root]');
  if (!root) return;
  const clock = root.querySelector('[data-om-clock]');
  if (clock) {
    const clockValue = clock.querySelector('[data-om-clock-value]');
    const dateFormat = new Intl.DateTimeFormat('en-US', { month: '2-digit', day: '2-digit' });
    const timeFormat = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
    const updateClock = () => {
      const now = new Date();
      clockValue.dateTime = now.toISOString();
      clockValue.querySelector('[data-om-clock-date]').textContent = dateFormat.formatToParts(now).filter(part => part.type === 'month' || part.type === 'day').map(part => part.value).join('');
      clockValue.querySelector('[data-om-clock-time]').textContent = timeFormat.formatToParts(now).filter(part => part.type !== 'dayPeriod').map(part => part.value).join('').trim();
      clock.hidden = false;
    };
    updateClock();
    let clockTimer = setInterval(() => { if (!document.hidden) updateClock(); }, 1000);
    window.addEventListener('pagehide', () => clearInterval(clockTimer));
    window.addEventListener('pageshow', event => { if (event.persisted) { updateClock(); clearInterval(clockTimer); clockTimer = setInterval(() => { if (!document.hidden) updateClock(); }, 1000); } });
  }
  const dialog = root.querySelector('[data-om-dialog]');
  const input = dialog.querySelector('[data-om-share-url]');
  const copy = dialog.querySelector('[data-om-copy]');
  const status = dialog.querySelector('[data-om-share-status]');
  const originalCopy = copy.textContent;
  const originalStatus = status.textContent;
  function openShare(title, url) {
    dialog.querySelector('[data-om-share-title]').textContent = title;
    input.value = url;
    copy.textContent = originalCopy;
    status.textContent = originalStatus;
    dialog.querySelector('[data-om-email]').href = 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url);
    dialog.querySelector('[data-om-x]').href = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(title) + '&url=' + encodeURIComponent(url);
    dialog.showModal();
  }
  const grid = root.querySelector('[data-om-grid]');
  const feedBreakpoint = matchMedia('(max-width: 899px)');
  const sizeStoryCards = () => {
    if (!grid || !root.classList.contains('om-home')) return;
    const columns = feedBreakpoint.matches ? 2 : 4;
    let filled = 0, regularSinceWide = 0;
    for (const card of grid.children) {
      const room = columns - filled % columns;
      const wide = card.dataset.landscape === 'true' && regularSinceWide >= 4 && room >= 2;
      card.classList.toggle('om-card-wide', wide);
      filled += wide ? 2 : 1;
      regularSinceWide = wide ? 0 : regularSinceWide + 1;
    }
  };
  sizeStoryCards();
  feedBreakpoint.addEventListener('change', sizeStoryCards);
  const pagination = root.querySelector('[data-om-pagination]');
  let more = root.querySelector('[data-om-more]');
  let loading = false;
  let observer;
  async function loadStories(automatic = false) {
    if (!more || loading) return;
    loading = true;
    const original = more.innerHTML;
    const loadStatus = root.querySelector('[data-om-load-status]');
    grid.setAttribute('aria-busy', 'true');
    more.setAttribute('aria-busy', 'true');
    loadStatus.textContent = more.dataset.loading;
    observer?.unobserve(pagination);
    try {
      const response = await fetch(more.href, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
      if (!response.ok) throw new Error('Fetch failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const cards = doc.querySelectorAll('[data-om-grid] [data-om-card]');
      if (!cards.length) throw new Error('No stories found');
      const ids = new Set([...root.querySelectorAll('[data-story-id]')].map(card => card.dataset.storyId));
      let firstAdded;
      cards.forEach(card => {
        if (ids.has(card.dataset.storyId)) return;
        const imported = document.importNode(card, true);
        grid.append(imported);
        ids.add(card.dataset.storyId);
        firstAdded ||= imported.querySelector('a');
      });
      sizeStoryCards();
      const next = doc.querySelector('[data-om-more]');
      loadStatus.textContent = '';
      if (next) {
        more.href = next.href;
        more.innerHTML = original;
        more.removeAttribute('aria-busy');
      } else {
        more.remove();
        more = null;
        observer?.disconnect();
      }
      if (!automatic) firstAdded?.focus({ preventScroll: true });
    } catch {
      observer?.disconnect();
      observer = null;
      more.hidden = false;
      more.innerHTML = original;
      more.removeAttribute('aria-busy');
      loadStatus.textContent = more.dataset.error;
    } finally {
      loading = false;
      grid.removeAttribute('aria-busy');
      if (more && observer) observer.observe(pagination);
    }
  }
  if (grid && pagination && more && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) loadStories(true);
    }, { rootMargin: '0px 0px 350px 0px' });
    more.hidden = true;
    observer.observe(pagination);
  }
  root.addEventListener('click', event => {
    const share = event.target.closest('[data-om-share]');
    if (share) {
      openShare(share.dataset.title, share.dataset.url);
      return;
    }
    const trigger = event.target.closest('[data-om-more]');
    if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    loadStories();
  });
  copy.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(input.value);
      dialog.close();
    } catch { input.focus(); input.select(); status.textContent = originalStatus; }
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
})();
